module.exports = __webpack_public_path__ + "static/media/montserrat-semi-bold.14eeabe0.woff2";